import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import QuoteInformationCard from '../../components/QuoteReviewComponents/QuoteInformationCard/QuoteInformationCard';
import InformationCard from '../../components/QuoteReviewComponents/InformationCard/InformationCard';
import AddDocumentsCard from '../../components/QuoteReviewComponents/AddDocumentsCard';
import QuoteBreakdown from '../../components/QuoteBreakdown';
import DefaultModal from '../../components/modals/DefaultModal';

const QuoteReviewBuyerScreen = () => {
  const { quoteNo } = useParams();
  const [showModal, setShowModal] = useState(false);

  const handleTabChange = () => {};

  return (
    <div className="flex flex-row">
      <div className="self-stretch">
        <Sidebar />
      </div>

      <div className="flex flex-col flex-grow px-10 max-w-screen">
        <div className="flex">
          <div className="flex flex-col flex-grow overflow-y-auto">
            <div className=" pb-7 space-y-3">
              <div className="flex flex-row w-full space-x-3">
                <img
                  alt="Logo"
                  src="/Rectangle_107.png"
                  className="rounded-lg w-96 h-[267px]"
                />
                <div className="w-full flex-grow">
                  <QuoteInformationCard
                    type={'quoteInformation'}
                    quoteNo={quoteNo}
                    buyerReviewScreen={true}
                  />
                </div>
              </div>
              <InformationCard
                type={'processAndFinish'}
                buyerReviewScreen={true}
              />
              <InformationCard
                type={'verificationAndValidation'}
                buyerReviewScreen={true}
              />
              <InformationCard type={'logistic'} buyerReviewScreen={true} />
              <div className="flex flex-row space-x-3 ">
                <div className="flex-grow flex flex-col space-y-3 max-w-[50%]">
                  <AddDocumentsCard />
                  <div className="min-w-screen flex-grow overflow-x-auto">
                    <div className="block p-5 pl-10 bg-white border border-[#DDDDDD] rounded-2xl h-full">
                      <div className="flex justify-between">
                        <h5 className="text-2xl tracking-tight text-gray-900 text-[25px]">
                          Additional Comments
                        </h5>
                      </div>
                      <div className="mt-6 bg-[#E5E5E5] block rounded-md py-3 px-5 text-gray-900 sm:text-sm sm:leading-6 flex-grow">
                        <div className="text-wrap">
                          <p>
                            {' '}
                            New Yorkers are facing the winter chill with less
                            warmth this year as the city's most revered soup
                            stand unexpectedly shutters, following a series of
                            events that have left the community puzzled. New
                            Yorkers are facing the winter chill with less warmth
                            this year as the city's most revered soup stand
                            unexpectedly shutters, following a series of events
                            that have left the community puzzled
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="basis-1/2">
                  <QuoteBreakdown rows={10} cols={57} />
                </div>
              </div>
              <div className="flex flex-row items-center justify-center space-x-4">
                <button
                  className="rounded-full px-8 py-2 text-[18px] text-left my-1 border-[1px] border-black"
                  onClick={() => handleTabChange('drop_files')}
                >
                  Close
                </button>
                <button
                  className="rounded-full px-8 py-2 text-[18px] text-left my-1 border-[1px] border-black"
                  onClick={() => handleTabChange('drop_files')}
                >
                  Update Quote
                </button>
                <button
                  className="rounded-full px-8 py-2 text-[18px] text-left my-1 bg-gradient-to-r from-[#8B5CF6] to-[#60A5FA] text-white"
                  onClick={() => setShowModal(true)}
                >
                  Accept
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showModal && (
        <DefaultModal
          heading="Thank You!"
          MainData="Your Order Has been Successfully placed"
          SecondaryData="Our team will get in touch with you shortly."
          ReturnTitle="Return to Dashboard"
          ButtonTitle="Dashboard"
          ButtonLink="/dashboard?tab=my_orders"
        />
      )}
    </div>
  );
};

export default QuoteReviewBuyerScreen;
